<template>
  <b-modal :ref="ref" :no-close-on-backdrop="true" :title="title">
    <div class="form-info">
      <div class="col">
        <div>
          <label>{{$t('labels.lots.lot_number')}}</label>
          <multiselect v-model="evaluationData.lot" :max-height="200"
                       placeholder="" label="lot_nr" track-by="id" :allow-empty="false"
                       :options="lots" :close-on-select="true" @input="lotChanged"
                       select-label="" deselect-label="" selected-label=""
                       :class="{required: !this.evaluationData.lot}"
          />
        </div>
        <div>
          <label>{{$t('labels.common.actual_price')}}, {{priceInfo}}</label>
          <input class="form-control" v-model.number="evaluationData.price_per_unit" disabled/>
        </div>
        <div class="d-flex justify-content-between">
          <div class="flex-grow-1 mr-2">
            <label>{{$t('labels.common.defect_value')}}, {{evaluationData.penalty_measure}}</label>
            <input class="form-control" v-model.number="evaluationData.penalty_value_nominal" :disabled="!isLotSelected"/>
          </div>
          <div style="flex-basis: 150px;">
            <label>{{$t('labels.common.defect_uom')}}</label>
            <multiselect v-model="evaluationData.penalty_measure" :max-height="200"
                         placeholder="" :options="measurements" :close-on-select="true" :disabled="!isLotSelected"
                         :allow-empty="false" select-label="" deselect-label="" selected-label=""
            />
          </div>
        </div>
        <div>
          <label>{{$t('labels.common.price_per_defect')}}, {{priceInfo}}</label>
          <input v-model.number="evaluationData.penalty" class="form-control" :disabled="!isLotSelected"/>
        </div>
        <div>
          <label>{{$t('labels.common.notes')}}</label>
          <input v-model.lazy="evaluationData.purchase_comment" class="form-control"/>
        </div>
      </div>
    </div>
    <div slot="modal-footer" class="w-100 text-center">
      <b-btn size="sm" variant="success" @click="save">
        {{$t('buttons.common.save')}}
      </b-btn>
    </div>
  </b-modal>
</template>

<script>
import Multiselect from 'vue-multiselect';
import { notificationsRenderer } from '@/helpers/renderHelpers';
import { handlerResponse, setNotifyData } from '@/helpers/commonHelpers';

const initialData = {
  lot: null,
  price_per_unit: 0,
  penalty_value_nominal: 0,
  penalty_measure: '%',
  penalty: 0,
  purchase_comment: ''
};

const url = 'woodware/movement_data/factual_evaluation/'

export default {
  components: { Multiselect },
  data() {
    return {
      ref: 'ActualEvaluationModal',
      evaluationData: {},
      lots: [],
      relatedPackages: null
    }
  },
  methods: {
    lotChanged() {
     const { id, ...lotData } = this.evaluationData.lot;
      this.evaluationData = {
        ...this.evaluationData,
        ...lotData
      }
    },
    async fetchActiveLots() {
      const params = {
        related_fields: 'lot',
        id: this.relatedPackages.toString()
      };
      const response = await this.$http.get(url, { params }).then(handlerResponse);
      this.lots = response.lot;
    },
    prepareSavedData() {
      const { isPackage, lot_nr, measure_type, currency_code, price_per_unit, lot, ...data } = this.evaluationData;
      const savedData = {
        ...data,
        lot: lot && lot.id,
        packets: this.relatedPackages
      };
      return savedData;
    },
    async save() {
      const payload = this.prepareSavedData();
      const loader = this.$loading.show();
      try {
        const response = await this.$http.put(url, payload).then(handlerResponse);
        this.$emit('save-evaluation');
        this.$refs[this.ref].hide();
      } catch(e) {
        notificationsRenderer(e.data, 'error')
      } finally {
        loader.hide();
      }
    }
  },
  computed: {
    isNew() {
      return !this.evaluationData.id;
    },
    priceInfo() {
      const lot = this.evaluationData.lot;
      if (lot) {
        const { currency_code, measure_type } = lot;
        return `${currency_code}/${measure_type}`
      }
      return '';
    },
    measurements() {
      const mesurements = ['%'];
      const lot = this.evaluationData.lot;
      if (lot) {
        return mesurements.concat(lot.measure_type);
      }
      return mesurements;
    },
    isPackage() {
      return this.evaluationData.isPackage;
    },
    title() {
      const i18n = this.$i18n;
      if (this.isPackage) {
        return `${i18n.t('modal_dialogs.package_nr')} ${this.evaluationData.package_nr}`;
      }
      if (this.isNew) {
        return i18n.t('modal_dialogs.actual_evaluation.create_item');
      }
      return i18n.t('modal_dialogs.actual_evaluation.edit_item');
    },
    isLotSelected() {
      return this.evaluationData.lot;
    }
  },
  mounted() {
    this.$root.$on('openActualEvaluationModal', async ({relatedPackages, ...data}) => {
      this.relatedPackages = relatedPackages;
      if (data) {
          if (data.lot) {
              const {price_per_unit} = data.lot;
              this.evaluationData = {...initialData, ...data, price_per_unit};
          } else {
              this.evaluationData = {...initialData, ...data};
          }
          await this.fetchActiveLots();
      } else {
          this.evaluationData = {...initialData}
      }
      if (this.$refs[this.ref]) {
        this.$refs[this.ref].show();
      }
    });
  },
  beforeDestroy() {
    this.$root.$off('openActualEvaluationModal');
  }
}
</script>




// WEBPACK FOOTER //
// src/components/modals/ActualEvaluationModal.vue